import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import {
  useJwtStorage,
  useLocalStorage,
} from "../../hooks/useLocalStorage";
import { isMobile } from "react-device-detect";
import SubTitle from "../../components/SubTitle";
import dayjs from "dayjs";

import Title from "../../components/Title";

import { useNavigate } from "react-router-dom";

import { getAnnouncements } from "../../services/AnnouncementService";
import { getDayForTeacher } from "../../services/ActivityService";

import DrawerAppBar from "../../components/DrawerAppBar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";

import { ReactComponent as PeopleAltIcon } from "../../icons/PeopleAlt24.svg";
import { ReactComponent as AssignmentTurnedInIcon } from "../../icons/AssignmentTurnedIn24.svg";
import { ReactComponent as TaskIcon } from "../../icons/Task24.svg";
import { ReactComponent as AddIcon } from "../../icons/Add24.svg";
import { ReactComponent as ResetIcon } from "../../icons/Reset24White.svg";
import { ReactComponent as CheckIcon } from "../../icons/Check24.svg";
import { ReactComponent as BlockIcon } from "../../icons/Block24.svg";
import { ReactComponent as TimerIcon } from "../../icons/Timer24.svg";
import { ReactComponent as DeleteIcon } from "../../icons/Delete24.svg";

import ProgressBar from "../../components/ProgressBar";
import StandardDetailedToggle from "../../components/StandardDetailedToggle";

import HeaderText from "../../components/HeaderText";

import clone from "lodash-es/clone";

import MessageLists from "../../components/MessageLists";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Link from "@mui/material/Link";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

import TableRowNoResults from "../../components/TableRowNoResults";
import CreatePassDialog from "../../components/faculty/CreatePassDialog";
import PassDetailsDialog from "../../components/faculty/PassDetailsDialog";
import AddQuickScore from "../../components/faculty/AddQuickScore";
import PaginatedTable from "../../components/PaginatedTable";

import { isFaculty } from "../../services/UserService";
import {
  deletePass,
  approvePass,
  rejectPass,
  returnPass,
  returnLatePass,
  didNotReturnPass,
  arrivedPass,
  didNotArrivePass,
  calcTimeRemain,
  addPassMinute,
  resetTimeout,
  getTodayAllTeacherPasses,
} from "../../services/PassService";
import {
  getTeacherSuggestedActivities,
  updateTeacherSuggestedActivity,
} from "../../services/ActivityService";
import { getTeacherMeetings } from "../../services/MeetingService";
import { doService } from "../../services/ServiceHelper";
import { useSetInterval } from "../../hooks/useSetInterval";
import {
  getPeriodName,
  isCheckinEnabled,
  isPassEnabled,
  getLocations,
} from "../../services/SchoolService";
import {
  formatHourMinute,
  secondsToMinutesAndSeconds,
} from "../../services/StringService";

import SETTINGS from "../../settings.json";
import TeacherMenu from "../../components/teacher/TeacherMenu";

import { getYYYYMMDD } from "../../services/DateService";
import { showToast } from "../../components/ATPDialogs";
import { getTeacherEvents } from "../../services/EventService";
import SearchBar from "../../components/faculty/SearchBar";
import {
  StripedTableRow,
  StripedTableCell,
} from "../../components/StripedTable";
import { getCheckinSummaries } from "../../services/ReportService";
import {
  getMyStudentScores,
  adminUpdateScoreTime,
} from "../../services/ScoreService";
import UpdateScoreTimeDialog from "../../components/faculty/report/UpdateScoreTimeDialog";

const TEACHER_WELCOME_TABS = {
  today: "today",
  score: "score",
  pass: "pass",
  messages: "messages",
};

const DEFAULT_TEACHER_HOME_TAB_ORDER = "today,score,pass";

const getTeacherHomeTabOrder = (school, isDetailedView) => {
  const requestedTabOrder = (
    school?.teacherHomeTabOrder || DEFAULT_TEACHER_HOME_TAB_ORDER
  )
    .split(",")
    .map((tab) => tab.trim())
    .filter((tab) =>
      [
        TEACHER_WELCOME_TABS.today,
        TEACHER_WELCOME_TABS.score,
        TEACHER_WELCOME_TABS.pass,
      ].includes(tab),
    );
  const orderedTabValues = [...new Set(requestedTabOrder)];

  if (orderedTabValues.length === 0) {
    orderedTabValues.push(...DEFAULT_TEACHER_HOME_TAB_ORDER.split(","));
  }

  if (isDetailedView) {
    orderedTabValues.push(TEACHER_WELCOME_TABS.messages);
  }

  return orderedTabValues;
};

const TeacherWelcome = () => {
  const isNativeCapacitor =
    typeof window !== "undefined" && !!window.Capacitor?.isNativePlatform?.();

  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_dashboardView, setDashboardView] = useLocalStorage(
    "TeacherWelcome",
    "dashboardView",
    "standard",
  );
  const [_showProgress, setShowProgress] = useState(false);

  const [_alerts, setAlerts] = useState([]);
  const [_infos, setInfos] = useState([]);
  const [_warnings, setWarnings] = useState([]);

  const [_todaysActivites, setTodaysActivities] = useState([]);
  const [_proctoredActivites, setProctoredActivities] = useState([]);

  const [_openPasses, setOpenPasses] = useState([]);
  const [_incomingPasses, setIncomingPasses] = useState([]);
  const [_todaysPasses, setTodaysPasses] = useState([]);
  const [_queuedPasses, setQueuedPasses] = useState([]);
  const [_showTodaysPasses, setShowTodaysPasses] = useState(false);
  const [_suggestedActivities, setSuggestedActivities] = useState([]);

  // key:pass eid
  const [_selectedOpenPassActions, setSelectedOpenPassActions] = useState({});
  const [_selectedIncomingPassActions, setSelectedIncomingPassActions] =
    useState({});

  const [_dialogCreatePassOpen, setDialogCreatePassOpen] = useState(false);

  const [_selectedPass, setSelectedPass] = useState({});
  const [_dialogPassDetailsOpen, setDialogPassDetailsOpen] = useState(false);
  const [_meetings, setMeetings] = useState([]);
  const [_events, setEvents] = useState([]);

  const [_studentsCheckedIn, setStudentsCheckedIn] = useState([]);
  const [_checkinCheckoutHistory, setCheckinCheckoutHistory] = useState([]);
  const [, setMetaSchoolComments] = useState([]);
  const [_myStudentScores, setMyStudentScores] = useState([]);
  const [_myStudentTotals, setMyStudentTotals] = useState([]);
  const [_passTimerStarted, setPassTimerStarted] = useState(false);

  const navigate = useNavigate();

  const STATUS_CREATED = 0;
  const STATUS_APPROVED = 50;
  const STATUS_PAST_TIMEOUT = 700;
  const isDetailedView = _dashboardView === "detailed";
  const orderedTabValues = getTeacherHomeTabOrder(_school, isDetailedView);
  const hasTodayTabContent =
    isCheckinEnabled(_school) === true ||
    (_school != null && _school.activitiesEnabled === "Y");
  const [_selectedTabIndex, setSelectedTabIndex] = React.useState(
    orderedTabValues[0] || TEACHER_WELCOME_TABS.today,
  );
  const [_timeOpen, setTimeOpen] = useState(false);
  const [_updatedTime, setUpdatedTime] = useState(null);
  const [_selectedScore, setSelectedScore] = useState({});
  const [_dashboardTitle, setDashboardTitle] = useState("Dashboard");
  const [_locations, setLocations] = useState([]);
  const [_defaultBathroomLocationId, setDefaultBathroomLocationId] = useState(null);

  useEffect(() => {
    initContent();
  }, [_school]);

  useEffect(() => {
    if (orderedTabValues.includes(_selectedTabIndex) === false) {
      setSelectedTabIndex(orderedTabValues[0] || TEACHER_WELCOME_TABS.today);
    }
  }, [_selectedTabIndex, orderedTabValues]);

  useEffect(() => {
    if (_passTimerStarted === false) {
      return;
    }

    const interval = setInterval(() => {
      initAllPasses();
    }, 20000);

    return () => clearInterval(interval);
  }, [_passTimerStarted]);

  useSetInterval(() => {
    const passes = clone(_openPasses);
    calcTimeRemain(passes);
    setOpenPasses(passes);
  }, 5000);

  const initLocations = () => {
    doService(getLocations(_school, _jwt), (result) => {
      const locations = [];
      for (const location of result.data) {
        locations.push({
          label: location.name,
          value: location.id,
        });
      }
      setLocations(locations);
    });
  };

  const isMeetingEnabled = (school) =>
    _school != null && _school.meetingEnabled === "Y";

  const isEventEnabled = (school) =>
    _school != null && _school.eventEnabled === "Y";

  const isScoreEnabled = () => {
    return _school != null && _school.scoreEnabled === "Y";
  };

  const initAnnouncements = () => {
    doService(getAnnouncements(_school, _jwt), (result) => {
      loadAnnouncements(result.data);
    });
  };

  const loadAnnouncements = (data) => {
    setAlerts(data.A);
    setInfos(data.I);
    setWarnings(data.W);
    if (
      data.dayType &&
      (_school.subdomain === "mavtime" || _school.subdomain === "hhs")
    ) {
      setDashboardTitle("Dashboard - " + data.dayType + " Day");
    }
  };

  /**
   * loads all data
   */
  const initContent = () => {
    initAnnouncements();

    if (isFaculty(_jwt)) {
      initTodayActivities();
    }

    if (isActivitiesEnabled() === true) {
      initSuggestedActivities();
    }

    if (isMeetingEnabled()) {
      initMeetings();
    }

    if (isEventEnabled()) {
      initEvents();
    }

    if (isCheckinEnabled(_school)) {
      initCheckins();
      setInterval(() => {
        initCheckins();
      }, 60000);
    }

    if (isPassEnabled(_school)) {
      initLocations();
      initAllPasses();
    }
  };

  const initCheckins = () => {
    doService(getCheckinSummaries(_school, _jwt), (results) => {
      setStudentsCheckedIn(results.data.studentsCheckedIn);
      setCheckinCheckoutHistory(results.data.checkinCheckoutHistory);
      setMetaSchoolComments(results.data.metaSchoolComments);
      setShowProgress(false);
    });
  };

  const initMeetings = () => {
    const startDate = getYYYYMMDD();

    getTeacherMeetings(_school, _jwt, startDate, startDate)
      .then((result) => {
        setMeetings(result.data);
      })
      .catch((error) => {
        console.log(error);
        showToast("E", "Unable to get Meetings.");
      })
      .finally(() => {});
  };

  const initEvents = () => {
    const startDate = getYYYYMMDD();

    getTeacherEvents(_school, _jwt, startDate, startDate)
      .then((result) => {
        setEvents(result.data);
      })
      .catch((error) => {
        console.log(error);
        showToast("E", "Unable to get Events.");
      })
      .finally(() => {});
  };

  const initSuggestedActivities = () => {
    doService(getTeacherSuggestedActivities(_school, _jwt), (result) => {
      setSuggestedActivities(result.data);
    });
  };

  const initAllPasses = () => {
    doService(getTodayAllTeacherPasses(_school, _jwt), (result) => {
      calcTimeRemain(result.data.open_passes);
      calcTimeRemain(result.data.incoming_passes);
      calcTimeRemain(result.data.today_passes);

      // reset all statuses for checkboxes
      const openPassActions = {};
      const incomingPassActions = {};
      const todaysPassActions = {};
      const queuedPassActions = {};

      for (let pass of result.data.open_passes) {
        openPassActions[pass.eid] = "XX";
      }
      for (let pass of result.data.incoming_passes) {
        incomingPassActions[pass.eid] = "XX";
      }
      for (let pass of result.data.today_passes) {
        todaysPassActions[pass.eid] = "XX";
      }
      for (let pass of result.data.queued_passes) {
        queuedPassActions[pass.eid] = "XX";
      }

      setSelectedOpenPassActions(openPassActions);
      setSelectedIncomingPassActions(incomingPassActions);

      setOpenPasses(result.data.open_passes);
      setTodaysPasses(result.data.today_passes);
      setIncomingPasses(result.data.incoming_passes);
      setQueuedPasses(result.data.queued_passes);

      if (result.data.default_locations) {
        setDefaultBathroomLocationId(result.data.default_locations.bathroom_location_id || null);
      }
    });
  };

  /**
   * retrieves today's activities and proctored activites
   */

  const initTodayActivities = () => {
    setShowProgress(true);
    doService(getDayForTeacher(_school, _jwt), (result) => {
      setTodaysActivities(result.data.activities);
      setProctoredActivities(result.data.proctored_activities);
      setShowProgress(false);
    });
  };

  const handleClickCreateActivity = () => {
    navigate(`/teacher/activity/create`);
  };

  const handleClickMyCalendar = () => {
    navigate(`/teacher/calendar`);
  };

  const handleClickThisWeek = () => {
    if (!isFaculty(_jwt)) {
      window.showAlert("Security", "User must be faculty.  Access audited.");
      return;
    }
    navigate(`/teacher/this-week`);
  };

  const handleClickCreatePass = () => {
    setDialogCreatePassOpen(true);
  };

  const handleClickStudents = (activity) => {
    navigate(`/teacher/ad/${activity.activityDateEid}/attendance/view`);
  };

  const handleClickAttendance = (activity) => {
    navigate(`/teacher/ad/${activity.activityDateEid}/attendance/take`);
  };

  const isActivitiesEnabled = () => {
    return _school != null && _school.activitiesEnabled === "Y";
  };

  const handleCreatePassClose = () => {
    setDialogCreatePassOpen(false);
  };

  const handleCreatePassOK = (students) => {
    setDialogCreatePassOpen(false);

    // already created, force reload of open/incoming passes
    initAllPasses();
  };

  const handleClickDeletePass = (pass) => {
    if (!window.confirm("Click OK to delete pass.")) {
      return;
    }

    doService(deletePass(_school, _jwt, pass.eid), (result) => {
      initAllPasses();
    });
  };

  const handleClickApprovePass = (pass) => {
    doService(approvePass(_school, _jwt, pass.eid), (result) => {
      initAllPasses();
    });
  };

  const handleClickRejectPass = (pass) => {
    const comment = window.prompt("Please enter comment (optional).");

    doService(rejectPass(_school, _jwt, pass.eid, comment), (result) => {
      initAllPasses();
    });
  };

  const handleClickArrived = (pass, comment) => {
    doService(arrivedPass(_school, _jwt, pass.eid, comment), (result) => {
      initAllPasses();
      showToast("S", "Status Updated");
    });
  };

  const handleClickDidNotArrive = (pass, comment) => {
    doService(didNotArrivePass(_school, _jwt, pass.eid, comment), (result) => {
      initAllPasses();
      showToast("S", "Status Updated");
    });
  };

  const handleClickReturnPass = (pass) => {
    doService(returnPass(_school, _jwt, pass.eid), (result) => {
      initAllPasses();
      showToast("S", "Pass Returned");
    });
  };

  const handleClickReturnLatePass = (pass) => {
    const comment = window.prompt("Please enter comment (optional).");

    doService(returnLatePass(_school, _jwt, pass.eid, comment), (result) => {
      initAllPasses();

      showToast("S", "Last Pass Returned");
    });
  };

  const handleClickDidNotReturnPass = (pass) => {
    const comment = window.prompt("Please enter comment (optional).");

    doService(didNotReturnPass(_school, _jwt, pass.eid, comment), (result) => {
      initAllPasses();

      showToast("S", "DNR Pass Returned");
    });
  };

  const handleChangeOpenAction = (action, pass) => {
    const actionValue =
      typeof action === "object" && action != null
        ? action.target?.value
        : action;

    // capture the selected item, then execute on that pass
    const selectedPassActions = clone(_selectedOpenPassActions);
    selectedPassActions[pass.eid] = actionValue;
    setSelectedOpenPassActions(selectedPassActions);

    switch (actionValue) {
      case "R":
        return handleClickReturnPass(pass);
      case "RL":
        return handleClickReturnLatePass(pass);
      case "DNR":
        return handleClickDidNotReturnPass(pass);
      case "AP":
        return handleClickApprovePass(pass);
      case "RE":
        return handleClickRejectPass(pass);
      case "DEL":
        return handleClickDeletePass(pass);
      default:
        return null;
    }
  };

  const getWhiteIcon = (IconComponent) => (props) => (
    <IconComponent
      {...props}
      style={{
        ...(props?.style || {}),
        width: 18,
        height: 18,
        display: "block",
        filter: "brightness(0) invert(1)",
      }}
    />
  );

  const iconActionButtonSx = {
    minWidth: 0,
    px: 1,
    py: 0.5,
    minHeight: 32,
    height: 32,
    borderRadius: 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSvgIcon-root, & svg": {
      width: 18,
      height: 18,
      display: "block",
    },
  };

  const getPassActionIcon = (value) => {
    switch (value) {
      case "AP":
        return CheckIcon;
      case "RE":
        return BlockIcon;
      case "AR":
        return getWhiteIcon(CheckIcon);
      case "R":
        return getWhiteIcon(CheckIcon);
      case "RL":
        return getWhiteIcon(TimerIcon);
      case "DNR":
        return getWhiteIcon(BlockIcon);
      case "DNA":
        return getWhiteIcon(BlockIcon);
      case "DEL":
        return DeleteIcon;
      default:
        return CheckIcon;
    }
  };

  const handleOpenActionIconClick = (pass, value) => {
    handleChangeOpenAction({ target: { value } }, pass);
  };

  const handleChangeIncomingAction = (event, pass) => {
    const action = event.target.value;
    // capture the selected item, then execute on that pass
    const selectedPassActions = clone(_selectedOpenPassActions);
    selectedPassActions[pass.eid] = action;
    setSelectedOpenPassActions(selectedPassActions);

    const comment = window.prompt("Add comment (optional)");

    switch (action) {
      case "AR":
        return handleClickArrived(pass, comment);
      case "DNA":
        return handleClickDidNotArrive(pass, comment);
      default:
        return null;
    }
  };

  const getPassAction = (selectedPassActions, pass) => {
    return selectedPassActions[pass.eid];
  };

  const handleClickPassDetails = (pass) => {
    setSelectedPass(pass);
    console.log(pass);
    setDialogPassDetailsOpen(true);
  };

  const handleClickPassDetailsClose = (doReload = false) => {
    setDialogPassDetailsOpen(false);

    if (doReload) {
      initAllPasses();
    }
  };

  const onTabChange = (event, tabName) => {
    setSelectedTabIndex(tabName);

    if (tabName === TEACHER_WELCOME_TABS.pass && _passTimerStarted === false) {
      setPassTimerStarted(true);
      initAllPasses();
    }
  };

  const handleClickSuggestionReviewed = (suggestion) => {
    doService(
      updateTeacherSuggestedActivity(_school, _jwt, suggestion.eid, 0),
      (result) => {
        initSuggestedActivities();
      },
    );
  };

  const handleClickSuggestionCreate = (suggestion) => {
    doService(
      updateTeacherSuggestedActivity(_school, _jwt, suggestion.eid, 100),
      (result) => {
        // redirect to create activity and send over name
        navigate(
          "/teacher/activity/create?name=" +
            encodeURIComponent(suggestion.name),
        );
      },
    );
  };

  const handleClickLeaveQrCode = () => {
    navigate(`/teacher/pass/leave`);
  };

  const handleClickReturnQrCode = () => {
    navigate(`/teacher/pass/return`);
  };

  const handleClickExcludedStudents = () => {
    navigate(`/faculty/pass/excluded-students`);
  };

  const handleClickKiosk = () => {
    navigate(`/faculty/pass/kiosk`);
  };

  const handleClickMeeting = (meeting) => {
    navigate(`/faculty/meetings`);
  };

  const handleClickEvent = (event) => {
    navigate(`/faculty/event/${event.eid}/attendance/take`);
  };

  const handleAddMinute = (eid) => {
    return doService(addPassMinute(_school, _jwt, eid), (results) => {
      initAllPasses();
    });
  };

  const handleResetTimeout = (eid) => {
    return doService(resetTimeout(_school, _jwt, eid), (results) => {
      initAllPasses();
    });
  };

  const initMyStudentScores = () => {
    if (_myStudentScores.length > 0) {
      return;
    }
    doService(getMyStudentScores(_school, _jwt), (results) => {
      setMyStudentScores(results.data.todaysScores);
      setMyStudentTotals(results.data.totals);
    });
  };

  const passSectionBoxSx = {
    border: "2px solid #64b5f6",
    borderRadius: 2,
    backgroundColor: "#f5f9ff",
    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.18)",
    pt: 0,
    pb: 1.25,
    pr: 1.25,
    pl: 1.25,
    mb: 2,
  };

  const renderPassSummary = (
    p,
    { showTimeoutDuration = false, showRemainingTime = false } = {},
  ) => (
    <div style={{ fontStyle: "italic" }}>
      {p.status === STATUS_CREATED && <>Created/Requested</>}
      {p.status === STATUS_APPROVED && <>Approved</>}{" "}
      {p.status === STATUS_PAST_TIMEOUT && <>Past Timeout</>}
      {showTimeoutDuration && p.status === STATUS_PAST_TIMEOUT && (
        <>
          <br />
          <span style={{ color: "red" }}>
            {secondsToMinutesAndSeconds(p.timeOverageSeconds)}
          </span>
        </>
      )}
      {showRemainingTime && p.timeRemainSeconds > 0 && (
        <>
          <br />
          Remaining: {secondsToMinutesAndSeconds(p.timeRemainSeconds)}
        </>
      )}
    </div>
  );

  const renderOpenStyleActionButton = (
    p,
    action,
    selectedPassActions,
    onClick,
  ) => {
    const ActionIcon = getPassActionIcon(action.value);
    const isSelected = getPassAction(selectedPassActions, p) === action.value;
    const isReturnedAction = action.value === "R";
    const isReturnedLateAction = action.value === "RL";
    const isDidNotReturnAction = action.value === "DNR";
    const isDeleteAction = action.value === "DEL";
    const buttonColor = isReturnedAction
      ? "success"
      : isReturnedLateAction
        ? "warning"
        : isDidNotReturnAction
          ? "error"
          : isSelected
            ? "primary"
            : "inherit";

    return (
      <Tooltip key={action.value} title={action.label}>
        <Button
          size="small"
          aria-label={action.label}
          variant={isSelected ? "contained" : "outlined"}
          color={buttonColor}
          onClick={() => onClick(p, action.value)}
          sx={{
            ...iconActionButtonSx,
            ...(isReturnedAction && {
              backgroundColor: (theme) => theme.palette.success.main,
              color: (theme) => theme.palette.success.contrastText,
              "&:hover": {
                backgroundColor: (theme) => theme.palette.success.main,
                color: (theme) => theme.palette.success.contrastText,
              },
            }),
            ...(isReturnedLateAction && {
              backgroundColor: (theme) => theme.palette.warning.main,
              color: (theme) => theme.palette.warning.contrastText,
              "&:hover": {
                backgroundColor: (theme) => theme.palette.warning.main,
                color: (theme) => theme.palette.warning.contrastText,
              },
            }),
            ...(isDidNotReturnAction && {
              backgroundColor: (theme) => theme.palette.error.main,
              color: (theme) => theme.palette.error.contrastText,
              "&:hover": {
                backgroundColor: (theme) => theme.palette.error.main,
                color: (theme) => theme.palette.error.contrastText,
              },
            }),
            ...(isDeleteAction && {
              color: (theme) => theme.palette.error.main,
              "&:hover": {
                color: (theme) => theme.palette.error.main,
              },
            }),
          }}
        >
          <ActionIcon />
        </Button>
      </Tooltip>
    );
  };

  const renderIncomingActionButton = (p, action) => {
    const ActionIcon = getPassActionIcon(action.value);
    const isSelected =
      getPassAction(_selectedIncomingPassActions, p) === action.value;
    const isArrivedAction = action.value === "AR";
    const isDidNotArriveAction = action.value === "DNA";
    const buttonColor = isArrivedAction
      ? "success"
      : isDidNotArriveAction
        ? "error"
        : isSelected
          ? "primary"
          : "inherit";

    return (
      <Tooltip key={action.value} title={action.label}>
        <Button
          size="small"
          aria-label={action.label}
          variant={isSelected ? "contained" : "outlined"}
          color={buttonColor}
          onClick={() =>
            handleChangeIncomingAction({ target: { value: action.value } }, p)
          }
          sx={{
            ...iconActionButtonSx,
            mr: 1,
            ...(isArrivedAction && {
              backgroundColor: (theme) => theme.palette.success.main,
              color: (theme) => theme.palette.success.contrastText,
              "&:hover": {
                backgroundColor: (theme) => theme.palette.success.main,
                color: (theme) => theme.palette.success.contrastText,
              },
            }),
            ...(isDidNotArriveAction && {
              backgroundColor: (theme) => theme.palette.error.main,
              color: (theme) => theme.palette.error.contrastText,
              "&:hover": {
                backgroundColor: (theme) => theme.palette.error.main,
                color: (theme) => theme.palette.error.contrastText,
              },
            }),
          }}
        >
          <ActionIcon />
        </Button>
      </Tooltip>
    );
  };

  const handleTimeClose = () => {
    setTimeOpen(false);
  };

  const onTimeClickOk = () => {
    const newDateTime = _updatedTime.format("YYYY-MM-DD HH:mm:00");

    setShowProgress(true);
    setTimeOpen(false);
    doService(
      adminUpdateScoreTime(_school, _jwt, _selectedScore.eid, newDateTime),
      (result) => {
        setShowProgress(false);
        showToast("S", "Score Time Updated");
        initCheckins();
      },
    );
  };

  const renderOpenStylePassesTable = (
    passes,
    ariaLabel,
    {
      showTimeoutDuration = false,
      showRemainingTime = false,
      justName = false,
    } = {},
  ) => (
    <TableContainer component={Paper} sx={{ mt: 0, mb: 2 }}>
      <Table aria-label={ariaLabel} size="small">
        <TableHead>
          <StripedTableRow>
            {justName === false && (
              <>
                <StripedTableCell width="50%">Details</StripedTableCell>
                <StripedTableCell style={{ whiteSpace: "nowrap" }}>
                  Return Pass
                </StripedTableCell>
                <StripedTableCell style={{ whiteSpace: "nowrap" }}>
                  Time
                </StripedTableCell>
                <StripedTableCell style={{ whiteSpace: "nowrap" }}>
                  Actions
                </StripedTableCell>
              </>
            )}
            {justName === true && (
              <>
                <StripedTableCell>Student Name</StripedTableCell>
              </>
            )}
          </StripedTableRow>
        </TableHead>
        <TableBody>
          {passes.map((p) => (
            <StripedTableRow key={p.eid}>
              {justName === true && (
                <StripedTableCell style={{ verticalAlign: "top" }}>
                  <Link
                    component={"button"}
                    onClick={() => handleClickPassDetails(p)}
                  >
                    {p.student_last_name}, {p.student_first_name}
                  </Link>
                </StripedTableCell>
              )}
              {justName === false && (
                <>
                  <StripedTableCell style={{ verticalAlign: "top" }}>
                    <Link
                      component={"button"}
                      onClick={() => handleClickPassDetails(p)}
                    >
                      {p.student_last_name}, {p.student_first_name}
                    </Link>
                    <br />
                    {renderPassSummary(p, {
                      showTimeoutDuration,
                      showRemainingTime,
                    })}
                  </StripedTableCell>
                  <StripedTableCell style={{ verticalAlign: "top" }}>
                    {(p.status === STATUS_APPROVED ||
                      p.status === STATUS_PAST_TIMEOUT) && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          width: "100%",
                        }}
                      >
                        {[
                          { value: "R", label: "RETURNED" },
                          { value: "RL", label: "RETURNED LATE" },
                          { value: "DNR", label: "DID NOT RETURN" },
                        ].map((action) =>
                          renderOpenStyleActionButton(
                            p,
                            action,
                            _selectedOpenPassActions,
                            (currentPass, actionValue) =>
                              handleOpenActionIconClick(
                                currentPass,
                                actionValue,
                              ),
                          ),
                        )}
                      </Box>
                    )}
                    {p.status === STATUS_CREATED && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          width: "100%",
                        }}
                      >
                        {[
                          { value: "AP", label: "APPROVE" },
                          { value: "RE", label: "REJECT" },
                        ].map((action) =>
                          renderOpenStyleActionButton(
                            p,
                            action,
                            _selectedOpenPassActions,
                            (currentPass, actionValue) =>
                              handleOpenActionIconClick(
                                currentPass,
                                actionValue,
                              ),
                          ),
                        )}
                      </Box>
                    )}
                  </StripedTableCell>
                  <StripedTableCell style={{ verticalAlign: "top" }}>
                    {(p.status === STATUS_APPROVED ||
                      p.status === STATUS_PAST_TIMEOUT) && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          width: "100%",
                        }}
                      >
                        <Tooltip title="Add Minute">
                          <Button
                            onClick={() => handleAddMinute(p.eid)}
                            className="button1"
                            sx={{
                              ...iconActionButtonSx,
                              minWidth: 0,
                              width: 64,
                              px: 0,
                            }}
                          >
                            + 1
                          </Button>
                        </Tooltip>

                        <Tooltip title="Reset Timeout">
                          <Button
                            size="small"
                            aria-label="Reset Timeout"
                            variant="contained"
                            onClick={() => handleResetTimeout(p.eid)}
                            sx={{
                              ...iconActionButtonSx,
                            }}
                            color="secondary"
                          >
                            <ResetIcon />
                          </Button>
                        </Tooltip>
                      </Box>
                    )}
                  </StripedTableCell>
                  <StripedTableCell style={{ verticalAlign: "top" }}>
                    {(p.status === STATUS_APPROVED ||
                      p.status === STATUS_PAST_TIMEOUT) && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          width: "100%",
                        }}
                      >
                        <Tooltip title="Delete Pass">
                          <Button
                            size="small"
                            aria-label="Delete Pass"
                            variant="outlined"
                            onClick={() => handleOpenActionIconClick(p, "DEL")}
                            sx={{
                              ...iconActionButtonSx,
                              color: (theme) => theme.palette.error.main,
                              "&:hover": {
                                color: (theme) => theme.palette.error.main,
                              },
                            }}
                          >
                            <DeleteIcon />
                          </Button>
                        </Tooltip>
                      </Box>
                    )}
                  </StripedTableCell>
                </>
              )}
            </StripedTableRow>
          ))}

          <TableRowNoResults data={passes} />
        </TableBody>
      </Table>
    </TableContainer>
  );

  const handleUpdateTime = (score) => {
    setUpdatedTime(dayjs(score.dateCreated));
    setSelectedScore(score);
    setTimeOpen(true);
  };

  const renderIncomingPassesTable = (passes) => (
    <TableContainer component={Paper} sx={{ mt: 0, mb: 0 }}>
      <Table aria-label="incoming passes" size="small">
        <TableHead>
          <StripedTableRow>
            <StripedTableCell>Student</StripedTableCell>
            <StripedTableCell>Actions</StripedTableCell>
          </StripedTableRow>
        </TableHead>
        <TableBody>
          {passes.map((p) => (
            <StripedTableRow key={p.eid}>
              <StripedTableCell style={{ verticalAlign: "top" }}>
                <Link
                  component={"button"}
                  onClick={() => handleClickPassDetails(p)}
                >
                  {p.student_last_name}, {p.student_first_name}
                </Link>
              </StripedTableCell>
              <StripedTableCell>
                {[
                  { value: "AR", label: "ARRIVED" },
                  { value: "DNA", label: "DID NOT ARRIVE" },
                ].map((action) => renderIncomingActionButton(p, action))}
              </StripedTableCell>
            </StripedTableRow>
          ))}

          <TableRowNoResults data={passes} />
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <>
      <DrawerAppBar />
      <SearchBar />

      <Container sx={{ mt: 1, ml: 0 }}>
        <Grid container spacing={1}>
          {isMobile === false && (
            <Grid item sx={{ width: 200, maxWidth: 200 }} className="sidebar">
              <TeacherMenu
                dashboardView={_dashboardView}
                onDashboardViewChange={setDashboardView}
              />
            </Grid>
          )}
          <Grid item sx={{ width: 800, maxWidth: "100%" }}>
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                justifyContent: "space-between",
              }}
            >
              <Title text={_dashboardTitle} />
              {!isNativeCapacitor && (
                <StandardDetailedToggle
                  value={_dashboardView}
                  onChange={setDashboardView}
                />
              )}
            </Box>

            <Container sx={{ mt: 1 }}>
              <ProgressBar showProgress={_showProgress} />
              {isScoreEnabled() === true && (
                <AddQuickScore
                  jwt={_jwt}
                  school={_school}
                  isDetailedView={isDetailedView}
                  onOK={() => {
                    initMyStudentScores();
                  }}
                />
              )}
              <Tabs value={_selectedTabIndex} onChange={onTabChange}>
                {orderedTabValues.map((tabValue) => (
                  <Tab
                    key={tabValue}
                    value={tabValue}
                    label={
                      tabValue === TEACHER_WELCOME_TABS.today
                        ? "Today"
                        : tabValue === TEACHER_WELCOME_TABS.score
                          ? "Score/Tardy"
                          : tabValue === TEACHER_WELCOME_TABS.pass
                            ? "Pass (" +
                              (_incomingPasses.length + _openPasses.length) +
                              ")"
                            : "Msg (" +
                              (_alerts.length +
                                _infos.length +
                                _warnings.length) +
                              ")"
                    }
                    sx={{
                      borderRight: "1px solid #ccc",
                      minHeight: 48,
                    }}
                    disabled={
                      tabValue === TEACHER_WELCOME_TABS.score &&
                      !isScoreEnabled()
                    }
                    onClick={() => {
                      if (tabValue === TEACHER_WELCOME_TABS.score) {
                        initMyStudentScores();
                      }
                    }}
                  />
                ))}
              </Tabs>{" "}
              {_selectedTabIndex === TEACHER_WELCOME_TABS.today && (
                <Container
                  sx={{
                    ml: 0,
                    border: "1px solid #e8e8e8",
                    pb: 2,
                    pl: 0,
                    mr: 0,
                    pr: 0,
                    width: 800,
                    maxWidth: "100%",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid
                      sx={{ pt: "0.5em !important" }}
                      item
                      xs={12}
                      md={12}
                      display="block"
                    >
                      {isCheckinEnabled(_school) === true && (
                        <>
                          <br />
                          <Grid container spacing={2} sx={{ mt: 0 }}>
                            <Grid item xs={4} md={4}>
                              <SubTitle
                                text={`Currently Checked In (${_studentsCheckedIn.length})`}
                              />
                              <TableContainer
                                component={Paper}
                                sx={{ mt: 1, mb: 2 }}
                              >
                                <Table size="small">
                                  <TableHead>
                                    <StripedTableRow>
                                      <StripedTableCell>
                                        Student Name
                                      </StripedTableCell>
                                    </StripedTableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRowNoResults
                                      data={_studentsCheckedIn}
                                    />
                                    {_studentsCheckedIn.map((student) => (
                                      <StripedTableRow>
                                        <StripedTableCell>
                                          {student.last_name},{" "}
                                          {student.first_name}
                                        </StripedTableCell>
                                      </StripedTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                            <Grid item xs={8} md={8}>
                              <SubTitle
                                text={`Today's Checkin History (${_checkinCheckoutHistory.length})`}
                              />

                              <PaginatedTable
                                defaultRowsPerPage={25}
                                rows={_checkinCheckoutHistory}
                                columns={[
                                  {
                                    name: "Date",
                                    align: "center",
                                    render: (row) => (
                                      <>
                                        {dayjs(row.dateCreated).format("MM/DD")}
                                      </>
                                    ),
                                  },
                                  {
                                    name: "Time",
                                    align: "center",
                                    render: (row) => (
                                      <>
                                        <Link
                                          component="button"
                                          onClick={() => handleUpdateTime(row)}
                                        >
                                          {dayjs(row.dateCreated).format(
                                            "hh:mm a",
                                          )}
                                        </Link>
                                      </>
                                    ),
                                  },
                                  {
                                    name: "Student Name",
                                    render: (row) => (
                                      <>
                                        {row.last_name}, {row.first_name}
                                      </>
                                    ),
                                  },
                                  {
                                    name: "Type",
                                    fieldName: "scoreCategoryName",
                                  },
                                ]}
                              />
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {hasTodayTabContent === false && (
                        <>
                          <br />
                          No content to display
                        </>
                      )}

                      {isActivitiesEnabled() === true && (
                        <>
                          <Grid container sx={{ mt: 2 }}>
                            <Grid item xs={4}>
                              <HeaderText text="Today's Activities" />
                            </Grid>
                            <Grid item xs={8} textAlign="right">
                              <Button
                                key="create an activity"
                                onClick={handleClickCreateActivity}
                                variant="contained"
                                sx={{ ml: 1 }}
                              >
                                + Create
                              </Button>
                              <Button
                                key="calendar"
                                onClick={handleClickMyCalendar}
                                variant="contained"
                                className="button1"
                                sx={{ ml: 1 }}
                                title="my calendar"
                              >
                                Calendar
                              </Button>
                              <Button
                                key="future"
                                onClick={handleClickThisWeek}
                                variant="outlined"
                                sx={{ ml: 1 }}
                                title="this week"
                              >
                                This Week
                              </Button>
                            </Grid>
                          </Grid>
                          <TableContainer
                            component={Paper}
                            sx={{ mt: 1, mb: 2 }}
                          >
                            <Table aria-label="today's activities" size="small">
                              <TableHead>
                                <StripedTableRow>
                                  <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                    Activity
                                  </StripedTableCell>
                                  <StripedTableCell
                                    sx={{ pt: 0, pb: 0 }}
                                    width={150}
                                  >
                                    Actions
                                  </StripedTableCell>
                                </StripedTableRow>
                              </TableHead>
                              <TableBody>
                                <TableRowNoResults
                                  text="No Activities Scheduled for Today."
                                  data={_todaysActivites}
                                />

                                {_todaysActivites.map((a) => (
                                  <StripedTableRow key={a.activityDateEid}>
                                    <StripedTableCell
                                      style={{ verticalAlign: "top" }}
                                    >
                                      <div>
                                        {getPeriodName(
                                          _school,
                                          a.period - 1,
                                          true,
                                          true,
                                        )}
                                        :
                                      </div>
                                      <Link
                                        className="link-pointer"
                                        onClick={() =>
                                          navigate(
                                            `/teacher/ad/${a.activityDateEid}/attendance/take`,
                                          )
                                        }
                                      >
                                        {a.name} ({a.location})
                                      </Link>
                                    </StripedTableCell>
                                    <StripedTableCell
                                      sx={{ pt: 1 }}
                                      style={{ verticalAlign: "top" }}
                                    >
                                      {a.attendanceModify === "Y" && _school.canViewViewAttendance === "Y" && (
                                        <Button
                                          key="signup"
                                          onClick={() => handleClickStudents(a)}
                                          sx={{ mb: 1, mr: 1 }}
                                          variant="contained"
                                          title="View Attendance"
                                        >
                                          <PeopleAltIcon />{" "}
                                        </Button>
                                      )}

                                      <Button
                                        className="button1"
                                        key="tmrw"
                                        onClick={() => handleClickAttendance(a)}
                                        sx={{ mb: 1 }}
                                        variant="contained"
                                        title="Take Attendance"
                                      >
                                        <AssignmentTurnedInIcon />
                                      </Button>
                                    </StripedTableCell>
                                  </StripedTableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          {_proctoredActivites.length > 0 && (
                            <>
                              <HeaderText text="Proctored Activities" />

                              <TableContainer component={Paper} sx={{ mt: 1 }}>
                                <Table
                                  aria-label="proctored activities"
                                  size="small"
                                >
                                  <TableHead>
                                    <StripedTableRow>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Activity
                                      </StripedTableCell>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Actions
                                      </StripedTableCell>
                                    </StripedTableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRowNoResults
                                      text="No Activities Scheduled for Today."
                                      data={_proctoredActivites}
                                    />

                                    {_proctoredActivites.map((a) => (
                                      <StripedTableRow key={a.activityDateEid}>
                                        <StripedTableCell
                                          style={{ verticalAlign: "top" }}
                                        >
                                          <div>
                                            {getPeriodName(
                                              _school,
                                              a.period - 1,
                                            )}
                                            :
                                          </div>
                                          <Link
                                            onClick={() =>
                                              navigate(
                                                `/activity/${a.activityDateEid}/attendance`,
                                              )
                                            }
                                          >
                                            {a.name} ({a.location})
                                          </Link>
                                        </StripedTableCell>
                                        <StripedTableCell>
                                          <Button
                                            key="signup"
                                            onClick={() =>
                                              handleClickStudents(a)
                                            }
                                            sx={{ mb: 1, mr: 1 }}
                                            variant="contained"
                                          >
                                            <PeopleAltIcon />
                                          </Button>
                                          <Button
                                            className="button1"
                                            key="tmrw"
                                            onClick={() =>
                                              handleClickAttendance(a)
                                            }
                                            sx={{ mb: 1 }}
                                            variant="contained"
                                          >
                                            <AssignmentTurnedInIcon />
                                          </Button>
                                        </StripedTableCell>
                                      </StripedTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </>
                          )}

                          {isMeetingEnabled() && (
                            <>
                              <HeaderText text="Today's Meetings" />
                              <TableContainer
                                component={Paper}
                                sx={{ mt: 1, mb: 2 }}
                              >
                                <Table
                                  aria-label="today's meetings"
                                  size="small"
                                >
                                  <TableHead>
                                    <StripedTableRow>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Time
                                      </StripedTableCell>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Title
                                      </StripedTableCell>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Type
                                      </StripedTableCell>
                                    </StripedTableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRowNoResults
                                      text="No Meetings Scheduled for Today."
                                      data={_meetings}
                                    />

                                    {_meetings &&
                                      _meetings.map((m) => (
                                        <StripedTableRow key={m.eid}>
                                          <StripedTableCell>
                                            {formatHourMinute(
                                              m.startHour,
                                              m.startMinute,
                                            )}
                                          </StripedTableCell>
                                          <StripedTableCell>
                                            <Link
                                              onClick={() =>
                                                handleClickMeeting(m)
                                              }
                                            >
                                              {m.title}
                                            </Link>
                                          </StripedTableCell>
                                          <StripedTableCell>
                                            {m.meetingTypeName}
                                          </StripedTableCell>
                                        </StripedTableRow>
                                      ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </>
                          )}

                          {isEventEnabled() && (
                            <>
                              <HeaderText text="Today's Events" />
                              <TableContainer
                                component={Paper}
                                sx={{ mt: 1, mb: 2 }}
                              >
                                <Table aria-label="today's events" size="small">
                                  <TableHead>
                                    <StripedTableRow>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Time
                                      </StripedTableCell>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Title
                                      </StripedTableCell>
                                      <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                        Type
                                      </StripedTableCell>
                                    </StripedTableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRowNoResults
                                      text="No Events Scheduled for Today."
                                      data={_events}
                                    />

                                    {_events.map((evt) => (
                                      <StripedTableRow key={evt.eid}>
                                        <StripedTableCell>
                                          {formatHourMinute(
                                            evt.startHour,
                                            evt.startMinute,
                                          )}
                                        </StripedTableCell>
                                        <StripedTableCell>
                                          <Link
                                            className="link-pointer"
                                            onClick={() =>
                                              handleClickEvent(evt)
                                            }
                                          >
                                            {evt.title}
                                          </Link>
                                        </StripedTableCell>
                                        <StripedTableCell>
                                          {evt.eventTypeName}
                                        </StripedTableCell>
                                      </StripedTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </>
                          )}

                          {isDetailedView &&
                            _suggestedActivities.length > 0 && (
                              <>
                                <HeaderText text={"Suggested Activities"} />

                                <TableContainer
                                  component={Paper}
                                  sx={{ mt: 0 }}
                                >
                                  <Table
                                    aria-label="suggested activities"
                                    size="small"
                                  >
                                    <TableHead>
                                      <StripedTableRow>
                                        <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                          Details
                                        </StripedTableCell>
                                        <StripedTableCell sx={{ pt: 0, pb: 0 }}>
                                          Actions
                                        </StripedTableCell>
                                      </StripedTableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRowNoResults
                                        data={_suggestedActivities}
                                      />
                                      {_suggestedActivities.map((a) => (
                                        <StripedTableRow key={a.dateCreated}>
                                          <StripedTableCell>
                                            <div>
                                              {" "}
                                              {dayjs(a.dateCreated).format(
                                                "MM/DD/YYYY",
                                              )}
                                            </div>
                                            {a.name}
                                          </StripedTableCell>
                                          <StripedTableCell>
                                            <Button
                                              key="reviewed"
                                              onClick={() =>
                                                handleClickSuggestionReviewed(a)
                                              }
                                              sx={{ mb: 1, mr: 1 }}
                                              variant="outlined"
                                            >
                                              <TaskIcon />
                                            </Button>
                                            <Button
                                              key="reviewed"
                                              onClick={() =>
                                                handleClickSuggestionCreate(a)
                                              }
                                              sx={{ mb: 1 }}
                                              variant="contained"
                                              className="buttonGreen"
                                            >
                                              <AddIcon />
                                            </Button>
                                          </StripedTableCell>
                                        </StripedTableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </>
                            )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                  <br />
                  {isDetailedView && <>BV: {SETTINGS.version}</>}
                </Container>
              )}
              {_selectedTabIndex === TEACHER_WELCOME_TABS.score && (
                <Container sx={{ ml: 0, pl: 0, border: "1px solid #e8e8e8" }}>
                  <HeaderText
                    text={`My Student Scores for Today (${_myStudentScores.length})`}
                  />

                  <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
                    <Table aria-label="my students" size="small">
                      <TableHead>
                        <StripedTableRow>
                          <StripedTableCell>Time</StripedTableCell>
                          <StripedTableCell>Student</StripedTableCell>
                          <StripedTableCell>Type</StripedTableCell>
                          <StripedTableCell>From</StripedTableCell>
                          <StripedTableCell>Consequence</StripedTableCell>
                        </StripedTableRow>
                      </TableHead>
                      <TableBody>
                        <TableRowNoResults data={_myStudentScores} />
                        {_myStudentScores.map((a) => (
                          <StripedTableRow key={a.studentEid}>
                            <StripedTableCell>
                              {dayjs(a.dateCreated).format("HH:mm")}
                            </StripedTableCell>
                            <StripedTableCell>
                              {a.last_name}, {a.first_name} ({a.grade})
                            </StripedTableCell>
                            <StripedTableCell>
                              {a.categoryName}
                            </StripedTableCell>
                            <StripedTableCell>
                              {a.teacherLastName}
                            </StripedTableCell>
                            <StripedTableCell>{a.conName}</StripedTableCell>
                          </StripedTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <HeaderText
                    text={`My Student Totals (${_myStudentTotals.length})`}
                  />

                  <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
                    <Table aria-label="my students" size="small">
                      <TableHead>
                        <StripedTableRow>
                          <StripedTableCell>Student</StripedTableCell>
                          <StripedTableCell align="center">
                            Count
                          </StripedTableCell>
                          <StripedTableCell>From</StripedTableCell>
                          <StripedTableCell>Type/Consequence</StripedTableCell>
                        </StripedTableRow>
                      </TableHead>
                      <TableBody>
                        <TableRowNoResults data={_myStudentTotals} />
                        {_myStudentTotals.map((a) => (
                          <StripedTableRow key={a.studentEid}>
                            <StripedTableCell>
                              {a.last_name}, {a.first_name} ({a.grade})
                            </StripedTableCell>
                            <StripedTableCell align="center">
                              {a.scoreValue}
                            </StripedTableCell>
                            <StripedTableCell>
                              {a.scoreValue > 0 && a.teacherLastName}
                            </StripedTableCell>
                            <StripedTableCell>
                              {a.scoreValue && (
                                <>
                                  <b>{a.categoryName}</b>
                                  <br />
                                  {a.conName}
                                </>
                              )}
                            </StripedTableCell>
                          </StripedTableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Container>
              )}
              {_selectedTabIndex === TEACHER_WELCOME_TABS.pass && (
                <Container
                  sx={{
                    ml: 0,
                    pl: 0,
                    mr: 0,
                    pr: 0,
                    border: "1px solid #e8e8e8",
                    width: 800,
                    maxWidth: "100%",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item sx={{ pt: "0.5em !important" }} xs={12} md={12}>
                      <br />
                      <Box
                        sx={{
                          border: "2px solid #64b5f6",
                          borderRadius: 2,
                          backgroundColor: "#f5f9ff",
                          boxShadow: "0 2px 8px rgba(25, 118, 210, 0.18)",
                          pt: 0,
                          pb: 1.25,
                          pr: 1.25,
                          pl: 1.25,
                          mb: 2,
                        }}
                      >
                        <Grid container spacing={1} sx={{ mt: 0.24 }}>
                          <Grid item sx={{ pt: "0.5em !important" }} xs={3}>
                            <Tooltip title="Create Pass: Use this option to create a pass for a student.">
                              <Button
                                key="signup"
                                onClick={handleClickCreatePass}
                                variant="contained"
                                fullWidth
                              >
                                Create
                              </Button>
                            </Tooltip>
                          </Grid>

                          <Grid item sx={{ pt: "0.5em !important" }} xs={3}>
                            <Tooltip title="Pass Kiosk: Use this option to allow students to create a pass from a single computer in your classroom.">
                              <Button
                                key="future"
                                onClick={handleClickKiosk}
                                variant="contained"
                                fullWidth
                              >
                                Kiosk
                              </Button>
                            </Tooltip>
                          </Grid>
                          {_school.qrEnabled === "Y" && (
                            <>
                              <Grid item sx={{ pt: "0.5em !important" }} xs={3}>
                                <Tooltip title="Leave QR Code: Use this option to leave a QR code for students to scan when leaving your classroom.">
                                  <Button
                                    key="tmrw"
                                    onClick={handleClickLeaveQrCode}
                                    variant="outlined"
                                    fullWidth
                                  >
                                    Leave QR
                                  </Button>
                                </Tooltip>
                              </Grid>
                              <Grid item sx={{ pt: "0.5em !important" }} xs={3}>
                                <Tooltip title="Return QR Code: Use this option to return a QR code that you previously left for students to scan when leaving your classroom.">
                                  <Button
                                    key="future"
                                    onClick={handleClickReturnQrCode}
                                    variant="outlined"
                                    fullWidth
                                  >
                                    Return QR
                                  </Button>
                                </Tooltip>
                              </Grid>
                              {isDetailedView && (
                                <Grid
                                  item
                                  sx={{ pt: "0.5em !important" }}
                                  xs={4}
                                >
                                  <Button
                                    key="future"
                                    onClick={handleClickExcludedStudents}
                                    variant="contained"
                                    fullWidth
                                  >
                                    Excluded Students
                                  </Button>
                                </Grid>
                              )}
                            </>
                          )}
                        </Grid>
                      </Box>
                      {_openPasses.length === 0 && (
                        <Typography variant="body2" color="textSecondary">
                          No current/open passes.
                        </Typography>
                      )}
                      {_openPasses.length > 0 && (
                        <Box sx={passSectionBoxSx}>
                          <HeaderText
                            text={
                              "Current/Open Passes (" + _openPasses.length + ")"
                            }
                          />
                          {renderOpenStylePassesTable(
                            _openPasses,
                            "open passes",
                            {
                              showTimeoutDuration: true,
                              showRemainingTime: true,
                            },
                          )}
                        </Box>
                      )}
                      {_queuedPasses.length === 0 && (
                        <Typography variant="body2" color="textSecondary">
                          No queued passes.
                        </Typography>
                      )}
                      {_queuedPasses.length > 0 && (
                        <Box sx={passSectionBoxSx}>
                          <HeaderText
                            text={
                              "Queued Passes (" + _queuedPasses.length + ")"
                            }
                          />
                          {renderOpenStylePassesTable(
                            _queuedPasses,
                            "queued passes",
                            {
                              showTimeoutDuration: true,
                              showRemainingTime: true,
                              justName: true,
                            },
                          )}
                        </Box>
                      )}
                      {_incomingPasses.length === 0 && (
                        <Typography variant="body2" color="textSecondary">
                          No incoming passes.
                        </Typography>
                      )}
                      {_incomingPasses.length > 0 && (
                        <Box sx={passSectionBoxSx}>
                          <HeaderText
                            text={
                              "Incoming Passes (" + _incomingPasses.length + ")"
                            }
                          />
                          {renderIncomingPassesTable(_incomingPasses)}
                        </Box>
                      )}
                      {_todaysPasses.length > 0 && (
                        <>
                          <Link
                            component="button"
                            onClick={() => setShowTodaysPasses((prev) => !prev)}
                            className="pull-right"
                            sx={{ mr: 2, mt: 1 }}
                          >
                            View Today's Passes
                          </Link>
                          <br />
                          <br />
                          {_showTodaysPasses && (
                            <>
                              <Box sx={passSectionBoxSx}>
                                <HeaderText
                                  text={
                                    "Today's Passes (" +
                                    _todaysPasses.length +
                                    ")"
                                  }
                                />
                                {renderOpenStylePassesTable(
                                  _todaysPasses,
                                  "today's passes",
                                )}
                              </Box>
                            </>
                          )}
                        </>
                      )}
                      <br /> <br />
                    </Grid>
                  </Grid>
                </Container>
              )}
              {_selectedTabIndex === TEACHER_WELCOME_TABS.messages && (
                <Container sx={{ ml: 0, pl: 0, border: "1px solid #e8e8e8" }}>
                  <HeaderText text={"Announcements:"} />

                  <MessageLists
                    alerts={_alerts}
                    infos={_infos}
                    warnings={_warnings}
                  />

                  {_alerts.length === 0 &&
                    _infos.length === 0 &&
                    _warnings.length === 0 && <>-- NO RESULTS RETURNED --</>}
                  <br />
                  <br />
                </Container>
              )}
            </Container>
          </Grid>
        </Grid>
      </Container>

      <CreatePassDialog
        open={_dialogCreatePassOpen}
        onClose={handleCreatePassClose}
        onOK={handleCreatePassOK}
        defaultBathroomLocationId={_defaultBathroomLocationId}
      />

      <PassDetailsDialog
        jwt={_jwt}
        school={_school}
        open={_dialogPassDetailsOpen}
        pass={_selectedPass}
        onClose={handleClickPassDetailsClose}
        allowToEdit={true}
        locations={_locations}
      />

      {_timeOpen && (
        <UpdateScoreTimeDialog
          value={_updatedTime}
          onChange={(djValue) => {
            setUpdatedTime(djValue);
          }}
          onClose={handleTimeClose}
          onOk={onTimeClickOk}
        />
      )}
    </>
  );
};

export default TeacherWelcome;
